import { render, staticRenderFns } from "./DeclarationGallery.vue?vue&type=template&id=9622c7f6&scoped=true&"
import script from "./DeclarationGallery.vue?vue&type=script&lang=ts&"
export * from "./DeclarationGallery.vue?vue&type=script&lang=ts&"
import style0 from "./DeclarationGallery.vue?vue&type=style&index=0&id=9622c7f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9622c7f6",
  null
  
)

export default component.exports